module.exports = __webpack_public_path__ + "static/f0862463.fr_banner.png";